<router-outlet />
<d-toast />
<p-confirmpopup />
<p-confirmdialog
	key="confirmDialog"
	styleClass="sc-confirm-dialog"
	[closeAriaLabel]="'accessibility.close_confirmation_dialog' | translate"
	[pt]="{
		pcCloseButton: {
			root: {
				'aria-label': ('accessibility.close_confirmation_dialog' | translate),
			},
		},
	}"
	rejectButtonStyleClass="p-button-secondary p-button-outlined"
/>
